<!-- キーワードから探す 入力欄 -->
<template>
  <input
    type="text"
    class="crly-a-common-search-keyword-input"
    :placeholder="placeholder"
    v-model="inputVal"
    @focusout="focusoutInput"
  />
</template>

<script>
export default {
  name: "CrlyAtomsCommonSearchKeywordInput",
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      placeholder: this.$t("search.keyword.input"),
      inputVal: ""
    };
  },
  methods: {
    focusoutInput() {
      this.$emit("focusoutKeyword", this.inputVal);
    }
  },
  mounted() {
    this.inputVal = this.value;
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/atoms/common/search/keyword/input.scss";
</style>
